const subscriptionTypes = [
  { label: "MarketIQ", value: "market_share" },
  { label: "Local Ad", value: "local_ad" },
  { label: "Local Spotlight", value: "fhls" },
  { label: "Legacy Pro Business", value: "lpro_business" },
];

export default subscriptionTypes;
